var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeftRight = function SvgChevronLeftRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 99 99"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.468,
    cy: 49.617,
    r: 49.218,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#036",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M37.003 37.364 24.75 49.617 37.003 61.87M61.935 37.364l12.252 12.253L61.936 61.87"
  })));
};
export default SvgChevronLeftRight;